import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

// core components
import Badge from "components/Badge";

// style
import {black500} from "assets/jss/main";

IncompleteCount.propTypes = {
    retailer: PropTypes.object.isRequired,
};

function renderPercentage(percentage) {
    if (percentage === 0 || percentage === undefined || percentage === null) {
        return null;
    }

    // Pour les incomplets : une baisse est positive (success), une hausse est négative (error)
    const color = percentage < 0 ? 'online' : 'error';
    const label = `${percentage > 0 ? '+' : ''}${percentage}%`;

    return <Badge color={color} label={label} size={'small'} />;
}

function IncompleteCount({retailer}) {
    const productCount = retailer.incompleteProductCount || 0;
    const variationCount = retailer.incompleteVariationCount || 0;
    const productPercentage = retailer.incompleteProductCountVariationPercentage;
    const variationPercentage = retailer.incompleteVariationCountVariationPercentage;

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
        }}>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                fontSize: '14px',
                fontWeight: 600,
                color: black500,
                whiteSpace: 'nowrap',
            }}>
                <FormattedMessage id="retailer.list.table.body.products" values={{count: productCount.toLocaleString('fr-FR')}} />
                {renderPercentage(productPercentage)}
            </div>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                fontSize: '12px',
                color: black500,
                whiteSpace: 'nowrap',
            }}>
                <FormattedMessage id="retailer.list.table.body.variations" values={{count: variationCount.toLocaleString('fr-FR')}} />
                {renderPercentage(variationPercentage)}
            </div>
        </div>
    );
}

export default IncompleteCount;
